import { render, staticRenderFns } from "./AppScope.vue?vue&type=template&id=5b684292&"
import script from "./AppScope.vue?vue&type=script&lang=js&"
export * from "./AppScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports